import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { Transition, TransitionGroup } from 'react-transition-group'

import GlobalStyle from 'styles/global-styles'
import { LayoutWrapper, PageWrapper, ContentWrapper } from './index.styled'

const LayoutContent = ({ children, location }) => {
  const nodeRef = useRef(null)

  return (
    <TransitionGroup component={null}>
      <Transition
        key={location.pathname}
        timeout={{ enter: 1000, exit: 1000 }}
        nodeRef={nodeRef}
      >
        {(status) => (
          <div
            ref={nodeRef}
            className={`page ${status}`}
            aria-hidden={status === 'exiting'}
          >
            <LayoutWrapper>{children}</LayoutWrapper>
          </div>
        )}
      </Transition>
    </TransitionGroup>
  )
}

const Layout = (props) => {
  const { children, location } = props

  return (
    <PageWrapper>
      <GlobalStyle />
      <ContentWrapper>
        <LayoutContent location={location}>{children}</LayoutContent>
      </ContentWrapper>
    </PageWrapper>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  location: PropTypes.object.isRequired
}

export default Layout
